<template>
  <div id="sign-off">
    <div class="logo">
      <img src="/frontend/img/rr_logo.svg">
    </div>
    <div class="formbox bg-white">
    <div id="content">
        <h1>{{lang.headers.success}}</h1>
        <p>{{lang.success_message}}</p>
        <p>{{lang.greeting}}</p>
        <p>Team RentRunner</p>
    </div>
    </div>
  </div>
</template>

<style scoped>
#none {
  height: 320px;
}

.damages-wrapper {
  width: 100%;
}


 .item {
     background: #ffffff;
     padding: 20px;
     border-radius: 10px;
     position: relative;
     margin: 20px 0;
 }
 .question {
     display: inline-block;
 }

 .question-answer {
     display: inline-block;
     width: 100%;
 }
  .question span {
     margin-left: 20px;
 }

 .row {
     display: flex;
     flex-wrap: wrap;
     column-gap: 25px;
     margin-left: inherit !important;
 }

  .logo {
     padding: 0 20px;
  }

  .logo img {
    height: 77px;
  }

  .formbox {
    padding: 20px;
    margin: 20px;
    /* background: #ededed; */
  }

</style>

<script>
export default {
  name: "contract-signoff-success",
  components: {},
  data() {
    return {
      lang: i18n.app.components.customer_sign_off
    };
  },
  mounted() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
};
</script>
